export default __webpack_public_path__ + "static/media/1812.8d270b83.png";